import { Block } from './blocks';

/** This only run fn against content blocks. Containers are not passed to the fn. */
export function walkBlocksContent(blocks: Block[], fn: (block: Block) => Block): Block[] {
  return blocks.map((block) => {
    if (block.type === 'section') {
      return {
        ...block,
        attrs: {
          ...block.attrs,
          blocks: walkBlocksContent(block.attrs.blocks as Block[], fn),
        },
      };
    }

    if (block.type === 'columns') {
      return {
        ...block,
        attrs: {
          ...block.attrs,
          columnBlocks: block.attrs.columnBlocks.map((colBlock) => {
            return walkBlocksContent(colBlock as Block[], fn);
          }),
        },
      };
    }

    return fn(block);
  });
}

export function resolveTrackedLinks(
  blocks: Block[],
  trackedLinks: Record<string, string>,
  siteUrl: string,
): Block[] {
  const fn = (block: Block): Block => {
    if (block.type === 'button' && block.attrs.trackHref) {
      const ref = trackedLinks[block.attrs.href];
      if (ref) {
        return {
          ...block,
          attrs: {
            ...block.attrs,
            href: `${siteUrl}/api/tracking/link/${ref}`,
          },
        };
      }
    }
    return block;
  };

  return walkBlocksContent(blocks, fn);
}
